import { render, staticRenderFns } from "./SearchedData.vue?vue&type=template&id=badf745c&scoped=true&"
import script from "./SearchedData.vue?vue&type=script&lang=js&"
export * from "./SearchedData.vue?vue&type=script&lang=js&"
import style0 from "./SearchedData.vue?vue&type=style&index=0&id=badf745c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "badf745c",
  null
  
)

export default component.exports